import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Typography,
  CardBody,
  CardTitle,
  IconButton,
} from '@one-thd/sui-atomic-components';
import { TrashCan } from '@one-thd/sui-icons';
import { useIsMobile } from '../ProjectLocation/helpers';

import {
  CustomCardActions,
  SquareFeet,
  CustomCard,
} from './styles';

function ModelCard(props) {

  const {
    name,
    len,
    width,
    sqt,
    key,
    id,
    deleteRoom,
    editRoom,
    forwardedRef,
  } = props;

  const unit = 'sq. ft';

  const isMobile = useIsMobile();

  return (
    <CustomCard style={{ display: 'block', }} key={key} id={id} ref={forwardedRef}>
      <CardTitle
        header={(
          <Typography
            variant="h3"
            weight="bold"
            style={{ wordBreak: 'break-word' }}
          >{name}
          </Typography>
        )}
        subheader={isMobile ?
          (
            <Typography>{` ${len} ft x ${width} ft`}&nbsp; &#8226;&nbsp;
              {sqt.toLocaleString('en-EN')}&nbsp;{unit}
            </Typography>
          ) : (
            <Typography style={{ color: 'gray' }}>
              {`${len} ft x ${width} ft`}
            </Typography>
          )}
      />
      <CardBody>
        {!isMobile ? (
          <SquareFeet>
            <Typography>{sqt.toLocaleString('en-EN')}&nbsp;{unit}</Typography>
          </SquareFeet>
        ) : null}
        <CustomCardActions>
          <Button
            variant="text"
            style={{
              justifyContent: 'start',
              alignItems: 'end',
              lineHeight: '1',
              borderBottomWidth: '1px',
              borderStyle: 'inset',
              paddingLeft: '0.1rem',
              paddingRight: '0.1rem'
            }}
            onClick={editRoom}
          > Edit
          </Button>
          <IconButton
            icon={TrashCan}
            arial-label="Delete Room"
            style={{ marginTop: '20px' }}
            onClick={deleteRoom}
          />
        </CustomCardActions>
      </CardBody>
    </CustomCard>
  );
}

ModelCard.propTypes = {
  key: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  len: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  sqt: PropTypes.string.isRequired,
  deleteRoom: PropTypes.func.isRequired,
  editRoom: PropTypes.func.isRequired,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ })
  ]),
};

ModelCard.defaultProps = {
  forwardedRef: {},
};

export default ModelCard;
